import { Box, styled } from '@mui/material';

export const NotFoundBookWrap = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '16px',
	flexDirection: 'column',
	marginBlock: '64px',

	paddingBlock: '64px',
}));
